import { Breakpoints } from '@volkswagen-onehub/components-core';
import React from 'react';

export function useBreakpointIsReached(breakpoint: number): boolean {
  const [breakpointIsReached, setBreakpointIsReached] = React.useState(
    Number.isFinite(breakpoint) ? breakpoint === Breakpoints.default : false
  );

  React.useEffect(() => {
    if (!Number.isFinite(breakpoint)) {
      return;
    }

    const mql = window.matchMedia(`(min-width: ${breakpoint}px)`);

    setBreakpointIsReached(mql.matches);

    const handleMediaQueryListener = (event: MediaQueryListEvent) => {
      setBreakpointIsReached(event.matches);
    };

    if (mql.addEventListener) {
      mql.addEventListener('change', handleMediaQueryListener);
    } else {
      // tslint:disable-next-line:deprecation for older browsers like mobile safari
      mql.addListener(handleMediaQueryListener);
    }

    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', handleMediaQueryListener);
      } else {
        // tslint:disable-next-line:deprecation for older browsers like mobile safari
        mql.removeListener(handleMediaQueryListener);
      }
    };
  }, [breakpoint]);

  return breakpointIsReached;
}
